<template>
    <div class="pos-relative">

        <div class="faq__search-component">

            <label></label>

            <input
                type="text"
                :placeholder="placeholder"
                class="faq__search-control"
                v-model="search"
                @input="searchInput"
                @keyup="searchKeyup"
            />

            <div class="faq__search-icon">
                <i class="fi fi-search"></i>
            </div>

            <div
                v-if="isClear"
                class="faq__search-icon faq__search-icon_type_is-close color-black"
                @click="searchInputClear"
            >
                <i class="fi fi-times"></i>
            </div>
        </div>

        <transition name="fade">

            <div class="faq__search-result" v-if="fadeIn">

                <div class="faq__search-list">

                    <div v-if="isSpinner" class="faq__search-spinner">
                        <span class="spinner spinner_size_medium"></span>
                    </div>

                    <template v-else>

                        <template v-if="isResultItem">

                            <div
                                class="faq__search-item"
                                v-for="(item, index) in resultItem"
                                :key="index.toString()"
                            >

                                <a :href="item.url" class="faq__search-link">
                                    <b>{{ item.title }}</b>
                                </a>
                            </div>
                        </template>
                        <div v-else class="faq__search-not-found">
                            {{ gettext('tpl:pages:faq:search:no_results') }}
                        </div>
                    </template>

                </div>
            </div>
        </transition>
    </div>
</template>


<script>
    import qs from 'qs';
    import { debounce } from '@/js/utils/common.js';

    const DELAY_SEARCH = 300;

    export default {
        name: "faq-search",

        data() {
            return {
                search: '',
                fadeIn: false,
                resultItem: {},
                isClear: false,
                isSpinner: false
            }
        },

        props: {
            placeholder: {
                type: String,
            },
        },

        methods: {
            searchInputClear() {
                this.search = '';
                this.resultItem = {};
                this.isClear = false;
                this.fadeIn = false;
            },
            searchInput() {
                if(this.search.length > 0) {
                    this.searchDebounced();
                    this.isClear = true;
                } else {
                    this.searchInputClear()
                }
            },
            searchKeyup(e) {
                const key = e.key;
                if (key === 'Backspace') {
                    this.search.length < 1 && this.searchInputClear();
                }
            },
            searchDebounced: debounce( function() {
                this.isSpinner = true;
                this.fetch()
            }, DELAY_SEARCH ),
            fetch() {

                axios.post('/faq', qs.stringify({
                    phrase: this.search
                }))
                    .then( res => {
                        let { data } = res.data;
                        this.isSpinner = false;

                        this.resultItem = Object.assign({}, data);

                        const resultItemLength = Object.keys(this.resultItem).length;

                        if(this.search.length > 0) {
                            this.fadeIn = true
                        } else if (resultItemLength > 0 && this.search.length < 1) {
                            this.fadeIn = false
                        }
                    });
            }
        },

        computed: {
            isResultItem() {
                return Object.keys(this.resultItem).length > 0;
            }
        }
    }
</script>

<style lang="less">
    @import (reference) '@/less/_breakpoint.less';
    @import (reference) '@/less/_helpers.less';
    @import (reference) '@/less/_helpers-forex.less';

    .faq {

        &__search-result {
            position: absolute;
            display: inline-block;
            border-radius: 2px;
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            contain: content;
            will-change: transform;
            box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
        }

        &__search-list {
            outline: none;
            text-decoration: none;
            transition-property: box-shadow, opacity;
            word-break: break-word;
            overflow-wrap: break-word;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
            display: block;
            position: relative;
            transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
            will-change: box-shadow;
            background: @color-white;
            border-radius: 0 0 4px 4px;
        }

        &__search-link {
            align-items: center;
            display: flex;
            flex: 1 1 100%;
            letter-spacing: normal;
            outline: none;
            position: relative;
            text-decoration: none;
            user-select: none;
            min-height: 30px;
            padding: 0 16px;
            color: @forex-color-dark;
            font-size: 12px;

            &:hover {
                color: @forex-color-green;
            }
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.25s ease-out;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>